import React, { useEffect, useState } from 'react';
import { isAndroid, isChrome } from 'react-device-detect';

import Button from '../../common/Button/Button';
import AnalyticsService from 'AnalyticsService';

import './AppDownload.scss';
import appDownload from '../../../assets/app-download.png';

const DOWNLOAD_BUTTON_TEXT = 'DOWNLOAD APP';
const INFO = ' Get the best experience and amazing offers on the app';
const ANDROID_URL = '#'; //https://halalbox.page.link/X1NC';
const IOS_URL = '#'; //'https://halalbox.page.link/cwXx';

export const AppDownload = ({ containerStyle, isSticky = false }) => {
  const [showAppDownload, setShowAppDownload] = useState(true);

  useEffect(() => {
    async function checkAppDownload() {
      if (isAndroid && isChrome && 'getInstalledRelatedApps' in navigator) {
        const relatedApps = await navigator.getInstalledRelatedApps();
        console.log('relatedApps : ', relatedApps);
        if (relatedApps.length > 0) {
          relatedApps.forEach(app => {
            console.log('app installed name : ', app);
            if (app?.platform === 'play' || app?.platform === 'webapp') {
              setShowAppDownload(false);
            }
          });
        }
      }
    }
    checkAppDownload();
  }, []);

  const openUrl = async () => {
    // const device = isAndroid ? 'Android' : 'IOS';
    // // Clevertap Analytics
    // const key = 'App Download';
    // const payload = {
    //   device,
    // };
    // AnalyticsService.clevertap.sendCleverTapEvent(key, payload);
    //
    // if (isAndroid) {
    //   window.open(ANDROID_URL);
    // } else {
    //   window.open(IOS_URL);
    // }
    if (window?.pwaInstallPrompt) {
      const result = await window.pwaInstallPrompt.prompt();
      console.log(`Install prompt was: ${result.outcome}`);
    }
  };

  return (
    <>
      {showAppDownload && (
        <div className={isSticky ? 'app-download--sticky' : {}}>
          <div
            className={
              containerStyle
                ? `app-download--container ${containerStyle}`
                : 'app-download--container'
            }
          >
            <div className="app-download--main" onClick={openUrl}>
              <div className="app-download--image-container">
                <img className="app-download--image" src={appDownload} />
              </div>
              <div className="app-download--info-container">
                <div className="app-download--info">{INFO}</div>
                <Button
                  className="app-download--button app-download--button-text"
                  onClick={() => openUrl()}
                >
                  {DOWNLOAD_BUTTON_TEXT}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
